import $ from "jquery";
import 'jquery-ui';
import 'detect-autofill';

require('../config/commonJs.js');

import {checkIsElement} from '../parts/common';
import '../../scss/controllers/site.scss';
import { parseTwoDigitYear } from "moment";

require('../parts/landing.js');

let formSubmitted = false;

const isAdaptive = $(window).width() < 769

const selectors = [
    '#resetpasswordform-password', 
    '#resetpasswordform-confirm_password', 
    '#passwordresetrequestform-username', 
    '#passwordresetrequestform-email', 
    '#loginform-password', 
    '#loginform-username', 
    '#signupform-username', 
    '#signupform-password', 
    '#signupform-confirm_password'
];

function countDown() {
    let countdownNumberEl = $('#countdown-number');
    let sec
    if (countdownNumberEl.data('time')) {
        sec = countdownNumberEl.data('time')
    }

    let countdown = sec ? sec - 1 : 60;
    let countdownFormatted = formatCountdown(countdown)

    if (sec) {
        $(countdownNumberEl).html(countdownFormatted)
    } else {
        $(countdownNumberEl).html(countdown)
    }

    if (!countdownNumberEl.is('.disabled')) {
        let progressOffset = -472
        let progressStep = -progressOffset / (sec ? sec - 1 : 60)
        let timeDown = setInterval(function () {
            countdown--;
            countdownFormatted = countdown;
            if (sec) {
                countdownFormatted = formatCountdown(countdown)
                if (countdown < 1) {
                    if ($('.verify-email').is('.email-verification')) {
                        $('.verify-email .basic').hide();
                        $('.verify-email .expired').show();
                    } else {
                        if (!countdownNumberEl.is('.no-reload')) {
                            location.reload()
                            return;
                        }
                    }
                }
            }
            $(countdownNumberEl).html(countdownFormatted);
            $('.timer circle:not(.trace)').css('stroke-dashoffset', progressOffset)
            progressOffset += progressStep
            if (!countdown) {
                $('.timer-block').addClass('times-out');
                if ($('.success-alert').length) {
                    $('.success-alert').show();
                }
                clearInterval(timeDown);
            }
        }, 1000);
    }
}

function initSubscriptions($handleElemSelector) {
    if (!checkIsElement($handleElemSelector)) return false;

    $handleElemSelector.find(".subscriptions-button").click(showSubscriptions);
    $(document).on("click", hideSubscriptions);
}

function showSubscriptions() {
    $(this).hide();
    $(this).next().show();
}

function hideSubscriptions(ev) {
    if (!$(ev.target).parents(".subscriptions-block").length) {
        $(".subscriptions").hide();
        $(".subscriptions-button").show();
    }
}

function checkSelectorFullness(){
    selectors.forEach(function(selector) {
        if ($(selector).length) {
            $(selector).trigger('change');
        }
    });
}

function initFakeCodeContainer() {
    if ($('.fake-code-container').length) {

        let container = $('.fake-code-container');
        let inputs = container.find('.code-container input');
        let form = container.closest('form');
        let trueInput = form.find('#mfaemailform-code');
        let fakeHelpBlock = container.find('.help-block');
        let helpBlock = $('.hide .help-block');

        setTimeout(function () {
            inputs.eq(0).trigger('focus')
        }, 1500)

        if ($(window).width() > 768) {
            $(inputs).attr('type', 'text');
        }

        // inputs.on('paste', function (e) {
        //     setTimeout(function () {
        //         let pastedValue = $(e.target).val();
        //         pastedValue = pastedValue.replace(/\n/g, '').replace(/\s/g, '');
        //         pastedValue = pastedValue.trim();
        //         let values = pastedValue.split('');
        //         inputs.each(function (index) {
        //             if (index < values.length) {
        //                 $(this).val(values[index]);
        //             } else {
        //                 $(this).val('');
        //             }
        //         });

        //         let otpValue = inputs.toArray().map((el) => el.value).join('');
        //         trueInput.val(otpValue).trigger('change');

        //         if (values.length) {
        //             inputs[5].focus();
        //         }
        //     }, 10);
        // });

        inputs.on('input', function (e) {
            let input = $(this);
            let value = input.val();

            if (value === '') {
                let currentIndex = inputs.index(this);
                if (currentIndex > 0) {
                    inputs[currentIndex].focus();
                }
            } else {
                value = value.replace(/[^0-9]/g, '');
                input.val(value);
            }

            let currentIndex = inputs.index(this);

            if (value.length === 1) {
                let nextIndex = currentIndex + 1;
                if (nextIndex < inputs.length) {
                    inputs[nextIndex].focus();
                }
            } else if (value.length > 1 && value.length < 5) {
                let nextIndex = currentIndex + 1;
                input.val(value[value.length - 1]);
                if (nextIndex < inputs.length) {
                    inputs[nextIndex].focus();
                }
            }

            let otpValue = inputs.toArray().map((el) => el.value).join('');
            trueInput.val(otpValue).trigger('change');
        });

        inputs.on('keydown', function (e) {
            // any keys except some key combination and digits would be restricted with the next code 
            if (
                // Allow digits (0-9)
                (e.keyCode >= 48 && e.keyCode <= 57) ||
                // Allow numeric keypad digits (96-105)
                (e.keyCode >= 96 && e.keyCode <= 105) ||
                // Allow Backspace (8)
                e.keyCode === 8 ||
                // Allow arrow keys (37 - left, 39 - right)
                (e.keyCode >= 37 && e.keyCode <= 40) ||
                // Allow Ctrl+C (67) and Ctrl+V (86) on Windows, Cmd+C (67) and Cmd+V (86) on Mac
                (e.ctrlKey || e.metaKey) && (e.keyCode === 67 || e.keyCode === 86)
            ) {
                // Continue with the normal behavior for these keys
            } else {
                // Prevent any other keys from being entered
                e.preventDefault();
            }

            if (e.keyCode === 8 && $(this).val() === '') {
                let currentIndex = inputs.index(this);
                if (currentIndex > 0) {
                    inputs[currentIndex - 1].focus();
                }
            }
        });

        inputs.on('click', function (e) {
            let currentIndex = inputs.index(this);
            let input = $(inputs[currentIndex])
            let tmpValue = input.val()
            input.focus();
            input.val('')
            input.val(tmpValue)
        });

        form.off('afterValidate').on('afterValidate', function () {
            setTimeout(function () {
                if(!formSubmitted){
                    let hasError = form.find('.field-mfaemailform-code').hasClass('has-error');
    
                    container.removeClass('has-success has-error').addClass(hasError ? 'has-error' : 'has-success');
    
                    if (trueInput.val().length === 6 && !hasError) {
                        form.find('.button-submit').removeClass('not-changed');
                        fakeHelpBlock.html('');
                        form.find('.button-submit').trigger('click')
                        formSubmitted = true;
                    } else {
                        form.find('.button-submit').addClass('not-changed');
                        fakeHelpBlock.text(helpBlock.text());
                        container.addClass('has-error')
                        formSubmitted = false;
                    }
    
                    if (trueInput.val().length < 6) {
                        container.removeClass('has-error')
                    }
                }
            }, 10);
        });
    }
}

function loadTurnstileScript() {
    const id = 'cf-turnstile-script';
    const old = document.getElementById(id);
    if (old) old.remove();
    if (window.turnstile) delete window.turnstile;

    return new Promise((resolve) => {
        const s   = document.createElement('script');
        s.id      = id;
        s.async   = s.defer = true;
        s.src     = 'https://challenges.cloudflare.com/turnstile/v0/api.js?cb=' + Date.now();
        s.onload  = resolve; 
        document.head.appendChild(s);
    });
}

function initTurnstileForms() {
    const formIds = ['form-signin', 'form-signup'];

    formIds.forEach(function(formId) {
        const form = document.getElementById(formId);
        if (!form) return;
        
        const turnstileTokenInput = form.querySelector('input[name="cf-turnstile-response"]');
        const recaptchaInput = form.querySelector('input[name$="[recaptcha]"]');
        if (turnstileTokenInput && recaptchaInput) {
            recaptchaInput.value = turnstileTokenInput.value;
        }
        
        form.removeEventListener('submit', form._turnstileHandler || (() => {}));

        const requiredIds = [
            'signupform-username',
            'signupform-email',
            'signupform-password',
            'signupform-confirm_password',
            'loginform-username',
            'loginform-password'
        ];

        const handler = function (e) {
            let hasError = false;
            for (const id of requiredIds) {
                const input = form.querySelector(`#${id}`);
                if (!input) continue;
                const val = input.value.trim();
                if (!val) {
                    hasError = true;
                    break;
                }
                if (id === 'signupform-email') {
                    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
                        hasError = true;
                        break;
                    }
                }
            }
            if (hasError) {
                return;
            }

            $('.cf-turnstile').show();
            setTimeout(() => { $('.cf-turnstile').hide(); }, 2000);
        };

        form.addEventListener('submit', handler);
        form._turnstileHandler = handler;
    });
}

$(document).ready(function () {
    initSubscriptions($(".subscriptions-block"));
    checkSelectorFullness()
    $('.js-tips__tabs').tabsIndicator({ 'hideMobile': false });

    if ($('.authorize-menu').length && $('.authorize-menu').hasClass('verify-email')) {
        initFakeCodeContainer()
        countDown()
        $('.js-tips__tabs').tabsIndicator({ 'hideMobile': false });
    }

    $('.login-page form .form-group input')
        .on('change autocomplete autofill', function () {
            let error = false
            $(this).closest('.authorize-menu').find('input.form-control').each(function () {
                if ($(this).val().length < 1) {
                    error = true;
                    return false;
                }
            })
            if (!error) {
                $('.not-changed').removeClass('not-changed')
            }
        })
        .on('keyup', function () {
            let input = $(this)
            clearTimeout(inputTimeout)
            inputTimeout = setTimeout(function () {
                input.trigger('change')
            }, 100)
        })

    if ($('#main5s').length) {
        $('body').css('overflow', 'hidden')
        setTimeout(function () {
            window.location = $("input[name*='redirectUrl']").val()
        }, 5000)
    }

    $(".js-main-slider").slick({
        dots: true,
        arrows: true,
        // autoplay: true,
        adaptiveHeight: true,
        // autoplaySpeed: 10000,
        speed: 1500,
        fade: true,
        cssEase: 'ease',
        nextArrow:
            '<a type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></a>',
        prevArrow:
            '<a type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></a>',
    });

    if ($("div").is(".featured_products") && $("div").is(".index-offers")) {
        $.ajax({
            success: function (data) {
                $(".featured_products .tab-pane").each(function () {
                    if (!$(this).is("active")) {
                        $(this).html(
                            $(data)
                                .find("#" + $(this).attr("id"))
                                .html()
                        );
                    }
                });
                $(".index-offers .tab-pane").each(function () {
                    if (!$(this).is("active")) {
                        $(this).html(
                            $(data)
                                .find("#" + $(this).attr("id"))
                                .html()
                        );
                    }
                });
                // $(window).lazyLoadXT();
            },
        });
    }
    
    $(".markets-list").slick({
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 6,
        centerMode: false,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        nextArrow:
            '<a type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></a>',
        prevArrow:
            '<a type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></a>',
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    centerMode: true,
                    arrows: false,
                    centerPadding: "60px",
                    speed: 10,
                },
            },
        ],
    });
    
    $(".mini-banner-slider").slick({
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        dots: false,
        arrows: true,
        infinite: true,
        nextArrow:
            '<a type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></a>',
        prevArrow:
            '<a type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></a>',
    });

    $(document).on("click", ".copy-label-up", function () {
        $(".copy-label-up").addClass("hide");
    });

    $(".affiliate-slider-1").slick({
        appendArrows: $(".items-slider .slider__nav"),
        autoplaySpeed: 10000,
        adaptiveHeight: true,
        speed: 500,
        arrows: true,
        infinite: true,

        responsive: [
            {
                breakpoint: 3000,
                settings: "unslick",
            },
            {
                breakpoint: 620,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    $(".affiliate-slider-2").slick({
        appendArrows: $(".items-slider .slider__nav-1"),
        autoplaySpeed: 10000,
        adaptiveHeight: true,
        speed: 500,
        arrows: true,
        infinite: true,

        responsive: [
            {
                breakpoint: 3000,
                settings: "unslick",
            },
            {
                breakpoint: 620,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    $(".affiliate-slider-3").slick({
        appendArrows: $(".items-slider .slider__nav-2"),
        autoplaySpeed: 10000,
        adaptiveHeight: true,
        speed: 500,
        arrows: true,
        infinite: true,

        responsive: [
            {
                breakpoint: 3000,
                settings: "unslick",
            },
            {
                breakpoint: 620,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    $(".affiliate-slider-4").slick({
        appendArrows: $(".items-slider .slider__nav-3"),
        autoplaySpeed: 10000,
        adaptiveHeight: true,
        speed: 500,
        arrows: true,
        infinite: true,

        responsive: [
            {
                breakpoint: 3000,
                settings: "unslick",
            },
            {
                breakpoint: 980,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 620,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    if (isAdaptive) {
        $(".affiliate-slider-1").slick({
            appendArrows: $(".items-slider .slider__nav"),
            autoplaySpeed: 10000,
            adaptiveHeight: true,
            speed: 500,
            arrows: true,
            infinite: true,

            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });

        $(".affiliate-slider-2").slick({
            appendArrows: $(".items-slider .slider__nav-1"),
            autoplaySpeed: 10000,
            adaptiveHeight: true,
            speed: 500,
            arrows: true,
            infinite: true,

            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });

        $(".affiliate-slider-3").slick({
            appendArrows: $(".items-slider .slider__nav-2"),
            autoplaySpeed: 10000,
            adaptiveHeight: true,
            speed: 500,
            arrows: true,
            infinite: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });

        $(".affiliate-slider-4").slick({
            appendArrows: $(".items-slider .slider__nav-3"),
            autoplaySpeed: 10000,
            adaptiveHeight: true,
            speed: 500,
            arrows: true,
            infinite: true,

            responsive: [
                {
                    breakpoint: 980,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    }
})

loadTurnstileScript().then(() => {
    setTimeout(()=>{initTurnstileForms()},1000)
});

$(document).on("click", "#form-signup", function () {
    const turnstileTokenInput = this.querySelector('input[name="cf-turnstile-response"]');
    const recaptchaInput = this.querySelector('input[name$="[recaptcha]"]');
    if (turnstileTokenInput && recaptchaInput) {
        recaptchaInput.value = turnstileTokenInput.value;
    }
});

$(document).on("click", "#form-signin", function () {
    const turnstileTokenInput = this.querySelector('input[name="cf-turnstile-response"]');
    const recaptchaInput = this.querySelector('input[name$="[recaptcha]"]');
    if (turnstileTokenInput && recaptchaInput) {
        recaptchaInput.value = turnstileTokenInput.value;
    }
});

$(document).on("click", ".js-tips__tab", function (e) {
    e.preventDefault();
    let pill = $(this).closest('.nav-pill');
    $(this).closest('.nav-tabs').find('.nav-pill').removeClass('active')
    pill.addClass("active")
    let href = $(this).attr("href")
    if (!href.startsWith('#')) {
        if (typeof href !== 'undefined' && href !== false || !href.startsWith("#")) {
            setTimeout(() => {
                $.pjax.reload("#pjax-wrap", {
                    url: href,
                });
            }, 300)
        }
    }
})

$(document).on("click", ".js-menu-moby .fa", function () {
    var li = $(this).parents("li");
    if ($(li).is(".active")) {
        $(li).removeClass("active");
    } else {
        $(li).addClass("active");
    }
});

$(document).on("click", ".js-view-password", function () {
    if ($(this).is(".active")) {
        $(this).removeClass("active");
        $($(this).attr("data-target")).prop("type", "password");
    } else {
        $(this).addClass("active");
        $($(this).attr("data-target")).prop("type", "text");
    }
});

$(document).on("change", "#form-signup #signupform-email", function () {
    var email = $(this).val();
    var login = email.split("@")[0];
    $('#form-signup #signupform-username').val(login);
    setTimeout(function () {
        $("#form-signup").yiiActiveForm("validateAttribute", "signupform-username");

    }, 1);

});

$(document).on("click", ".show-all", function () {
    $(".item.hide-item").show();
    $(this).hide();
});

$(document).on("click", ".featured_products .nav-link", function () {
    $("html, body").animate(
        {
            scrollTop: $(".featured_products").offset().top - 150,
        },
        500
    );
});

$(document).on('keypress keyup input change', '#signupform-email', function () {
    let reg = /[а-яА-ЯёЁґҐєЄіІїЇ]/g;
    if (this.value.search(reg) != -1) {
        this.value = this.value.replace(reg, '');
        $(this).closest(".form-group").addClass('has-error').find('.help-block-error').text($(this).attr('data-error'))
    }
    this.value = this.value.replace(/[^a-zA-Z0-9.@\-_]/g, "");
});

$(document).on('keypress keyup input change', selectors.join(', '), function() {
    let reg = /[а-яА-ЯёЁґҐєЄіІїЇ]/g;
    if (this.value.search(reg) != -1) {
        this.value = this.value.replace(reg, '');
        $(this).closest(".form-group").addClass('has-error').find('.help-block-error').text($(this).attr('data-error'))
    }

    this.value = this.value.replace(/\s/g, '');
});

$(document).on('keypress keyup input change', '#signupform-password', function () {
    $(this).closest('form').find('.requirements-wrap').addClass('active')
})

$(document).on('onautocomplete',function(){
    checkSelectorFullness()
})

$(document).on("pjax:success", function (event) {
    checkSelectorFullness()
    loadTurnstileScript().then(() => {
        setTimeout(()=>{initTurnstileForms()},1000)
    });
    if ($('#main5s').length) {
        $('body').css('overflow', 'hidden')
        setTimeout(function () {
            window.location = $("input[name*='redirectUrl']").val()
        }, 5000)
    }

    if ($('.authorize-menu').length && $('.authorize-menu').hasClass('verify-email')) {
        initFakeCodeContainer()
        countDown()
    }

    $('.js-tips__tabs').tabsIndicator({ 'hideMobile': false });

    $('.login-page form .form-group input')
        .on('change autocomplete autofill', function () {
            let error = false
            $(this).closest('.authorize-menu').find('input.form-control').each(function () {
                if ($(this).val().length < 1) {
                    error = true;
                    return false;
                }
            })
            if (!error) {
                $('.not-changed').removeClass('not-changed')
            }
        })
        .on('keyup', function () {
            let input = $(this)
            clearTimeout(inputTimeout)
            inputTimeout = setTimeout(function () {
                input.trigger('change')
            }, 100)
        })
});